export default function FilterToggleChip({
    label,
    on,
    disabled,
    onClick,
}: {
    label: string;
    on: boolean;
    disabled?: boolean;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            disabled={disabled}
            onClick={onClick}
            style={{
                height: 30,
                padding: '0 13px',
                borderRadius: 'var(--cpm-radius-full)',
                border: `1.5px solid ${on ? 'var(--cpm-brand-purple)' : 'var(--cpm-border-strong)'}`,
                background: on ? 'var(--cpm-purple-selected)' : '#fff',
                fontSize: 12.5,
                fontWeight: 800,
                cursor: disabled ? 'not-allowed' : 'pointer',
            }}
        >
            {label}
        </button>
    );
}
